var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import axios from "axios";
import { useEffect, useState } from "react";
import { MEETING_ENDPOINTS } from "../../../utils/endpoints";
import { TeamsMeetingCandidate } from "../../../components/meeting-gui-candidate";
import { metaDataParamsKey } from "../../middleware";
const CandidateMeeting = () => {
    const [acsToken, setAcsToken] = useState();
    const [updateData, setUpdateData] = useState();
    useEffect(() => {
        getCandidateAccessToken();
    }, []);
    useEffect(() => {
        const updateDataLocal = JSON.parse(sessionStorage.getItem(metaDataParamsKey));
        setUpdateData(updateDataLocal);
    }, []);
    const getCandidateAccessToken = () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield axios({
            method: "GET",
            url: `${MEETING_ENDPOINTS.GET_ACS_TOKEN}`,
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        });
        const data = response === null || response === void 0 ? void 0 : response.data;
        setAcsToken(typeof data === "string" ? data : data === null || data === void 0 ? void 0 : data.token);
    });
    return (_jsx("div", { children: acsToken && updateData && (_jsx(TeamsMeetingCandidate
        //   locator={updateData?.meetingLink}
        , { 
            //   locator={updateData?.meetingLink}
            token: acsToken, userId: {
                communicationUserId: "",
            }, displayName: "Candidate", 
            //   endpointUrl={"https://teams.microsoft.com/v2/?meetingjoin=true#/l/meetup-join/19:meeting_YjBkMzcwMGItZjkzZi00NTkyLWFmMjEtNmFmZTEyMzYzYzM1@thread.v2/0?context=%7b%22Tid%22%3a%22c1117dd5-465f-4ec6-86c2-c708d2e0ab15%22%2c%22Oid%22%3a%22971971b6-fc8c-47c1-a411-ed62ec162946%22%7d&anon=true&deeplinkId=bee86e90-0cbe-47e9-a486-4a7be80e2af8"}
            callInvitationURL: updateData === null || updateData === void 0 ? void 0 : updateData.meetingLink, locator: updateData === null || updateData === void 0 ? void 0 : updateData.meetingLink })) }));
};
export default CandidateMeeting;
